import React from "react";
import ExistingPhotoPicker from "./ExistingPhotoPicker";
import PhotoUploader from "./PhotoUploader";

export default function HeroEditor({ clientId, hero, name, slug, onChange, onNameChange, onSlugChange }) {
  return (
    <fieldset style={{ marginBottom: 24 }}>
      <legend><strong>Hero</strong></legend>
      <label>Nom complet
        <input value={name || ""}
               onChange={(e) => onNameChange(e.target.value)}
               style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
      </label>
      <label>Slug (URL : &lt;slug&gt;.minibio.pro)
        <input value={slug || ""}
               onChange={(e) => onSlugChange(e.target.value)}
               style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
      </label>
      <label>Sous-titre
        <input value={hero?.subtitle || ""}
               onChange={(e) => onChange({ ...hero, subtitle: e.target.value })}
               style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
      </label>
      <div>Photo hero</div>
      <PhotoUploader
        clientId={clientId}
        slot="hero"
        currentFilename={hero?.photo_filename}
        onChange={(filename) => onChange({ ...hero, photo_filename: filename })}
      />
      <ExistingPhotoPicker
        clientId={clientId}
        onChange={(filename) => onChange({ ...hero, photo_filename: filename })}
      />
    </fieldset>
  );
}
